/* Created by Interactive 63 - https://interactive63.com */
/**
 * Tells other tabs when a project has been saved, so a tab holding the same project can offer to
 * reload it. Where BroadcastChannel is missing the sync is simply off.
 */

const CHANNEL_NAME = 'svg-tempo';

interface SavedMessage {
  type: 'saved';
  projectId: string;
  senderId: string;
}

export class TabSync {
  private readonly channel: BroadcastChannel | undefined;
  private readonly senderId = Math.random().toString(36).slice(2);

  /** Opens the channel. `name` is overridable so tests stay isolated. */
  constructor(name = CHANNEL_NAME) {
    this.channel = typeof BroadcastChannel === 'undefined' ? undefined : new BroadcastChannel(name);
  }

  /** Announces that this tab saved the project. */
  notifySaved(projectId: string): void {
    const message: SavedMessage = { type: 'saved', projectId, senderId: this.senderId };
    this.channel?.postMessage(message);
  }

  /** Calls the listener with the project ID whenever another tab saves a project. */
  onSavedElsewhere(listener: (projectId: string) => void): void {
    this.channel?.addEventListener('message', (event: MessageEvent<unknown>) => {
      const data = event.data as Partial<SavedMessage> | null;
      if (
        data?.type === 'saved' &&
        typeof data.projectId === 'string' &&
        data.senderId !== this.senderId
      ) {
        listener(data.projectId);
      }
    });
  }
}
